import { render, staticRenderFns } from "./BuyOrderManage.vue?vue&type=template&id=4f61dde5&scoped=true&"
import script from "./BuyOrderManage.vue?vue&type=script&lang=js&"
export * from "./BuyOrderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61dde5",
  null
  
)

export default component.exports